import { User } from "@cabukaka/types"
import { dataService } from "./core/dataService"


export const userService = {
  get baseService() {
        return dataService<User>("users");
    },  

  
}